

$(document).ready(function(){

if ($("div.js-slick-carousel").length > 0) {
              	
                var slick = $("div.js-slick-carousel");
                slick.each(function(){
                  
                  var slidestoshow = $(this).data('slidestoshow');
              	  var slidestoscroll = $(this).data('slidestoscroll');
                  
                  var slidestoshowipadpro = $(this).data('slidestoshowipadpro');
              	  var slidestoscrollipadpro = $(this).data('slidestoscrollipadpro');
                  
                  var slidestoshowipad = $(this).data('slidestoshowipad');
              	  var slidestoscrollipad = $(this).data('slidestoscrollipad');
                  
                  var slidestoshowmobile = $(this).data('slidestoshowmobile');
              	  var slidestoscrollmobile = $(this).data('slidestoscrollmobile');
                  
                  var slidestoshowmobilevertical = $(this).data('slidestoshowmobilevertical');
              	  var slidestoscrollmobilevertical = $(this).data('slidestoscrollmobilevertical');
                  
                  var rows = $(this).data('rows');
                  var arrows = $(this).data('arrows');
                  var dots = $(this).data('dots');
                  var autoplay = $(this).data('autoplay');
                  var infinite = $(this).data('infinite');
                  var appendDots = $(this).parent().find('.ttrend_append_dots');
                  var settings = {
                        lazyLoad:'ondemand',
                        slidesToShow: slidestoshow,
                        slidesToScroll: slidestoscroll,
                        arrows: arrows,
                        dots: dots,
                        pauseOnHover:true,
                        autoplay: autoplay,
                        autoplaySpeed:'5000',
                        
                        infinite: infinite,
                        appendDots: appendDots,
                  		responsive: [
                          	{
                                breakpoint: 1400,
                                settings: {
                                    dots: dots,
                                    arrows: arrows,
                                    infinite: infinite,
                                  	autoplay: autoplay,
                                    slidesToShow: slidestoshowipadpro,
                                    slidesToScroll: slidestoscrollipadpro
                                }
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    dots: dots,
                                    arrows: arrows,
                                    infinite: infinite,
                                  	autoplay: autoplay,
                                    slidesToShow: slidestoshowipad,
                                    slidesToScroll: slidestoscrollipad
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    dots: dots,
                                    arrows: arrows,
                                  	autoplay:autoplay,
                                    infinite: infinite,
                                    slidesToShow: slidestoshowmobile,
                                    slidesToScroll: slidestoscrollmobile
                                }
                            },
                          	{
                                breakpoint: 480,
                                settings: {
                                    dots: dots,
                                    arrows: arrows,
                                  	autoplay:autoplay,
                                    infinite: infinite,
                                    slidesToShow: slidestoshowmobilevertical,
                                    slidesToScroll: slidestoscrollmobilevertical
                                }
                            }
                          
                        ]
                  };
                  	
                  if(rows){
                    $.extend(settings, {
                        rows: rows,
                    });
                  }
                  
                  $(this).slick(settings);
                          
                })
               }

 });

function slickCarousel(){
if ($("div.tt-product-recommendation-slick").length > 0) {
              	
                var slick = $("div.tt-product-recommendation-slick");
                slick.each(function(){
                  
                  var slidestoshow = $(this).data('slidestoshow');
              	  var slidestoscroll = $(this).data('slidestoscroll');
                  
                  var slidestoshowipadpro = $(this).data('slidestoshowipadpro');
              	  var slidestoscrollipadpro = $(this).data('slidestoscrollipadpro');
                  
                  var slidestoshowipad = $(this).data('slidestoshowipad');
              	  var slidestoscrollipad = $(this).data('slidestoscrollipad');
                  
                  var slidestoshowmobile = $(this).data('slidestoshowmobile');
              	  var slidestoscrollmobile = $(this).data('slidestoscrollmobile');
                  
                  var slidestoshowmobilevertical = $(this).data('slidestoshowmobilevertical');
              	  var slidestoscrollmobilevertical = $(this).data('slidestoscrollmobilevertical');
                  
                  var rows = $(this).data('rows');
                  var arrows = $(this).data('arrows');
                  var dots = $(this).data('dots');
                  var autoplay = $(this).data('autoplay');
                  var infinite = $(this).data('infinite');
                  var appendDots = $(this).parent().find('.ttrend_append_dots');
                  var settings = {
                        lazyLoad:'ondemand',
                        slidesToShow: slidestoshow,
                        slidesToScroll: slidestoscroll,
                        arrows: arrows,
                        dots: dots,
                        pauseOnHover:true,
                        autoplay: autoplay,
                        autoplaySpeed:'5000',
                        
                        infinite: infinite,
                        appendDots: appendDots,
                  		responsive: [
                          	{
                                breakpoint: 1400,
                                settings: {
                                    dots: dots,
                                    arrows: arrows,
                                    infinite: infinite,
                                  	autoplay: autoplay,
                                    slidesToShow: slidestoshowipadpro,
                                    slidesToScroll: slidestoscrollipadpro
                                }
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    dots: dots,
                                    arrows: arrows,
                                    infinite: infinite,
                                  	autoplay: autoplay,
                                    slidesToShow: slidestoshowipad,
                                    slidesToScroll: slidestoscrollipad
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    dots: dots,
                                    arrows: arrows,
                                  	autoplay:autoplay,
                                    infinite: infinite,
                                    slidesToShow: slidestoshowmobile,
                                    slidesToScroll: slidestoscrollmobile
                                }
                            },
                          	{
                                breakpoint: 480,
                                settings: {
                                    dots: dots,
                                    arrows: arrows,
                                  	autoplay:autoplay,
                                    infinite: infinite,
                                    slidesToShow: slidestoshowmobilevertical,
                                    slidesToScroll: slidestoscrollmobilevertical
                                }
                            }
                          
                        ]
                  };
                  	
                  if(rows){
                    $.extend(settings, {
                        rows: rows,
                    });
                  }
                  
                  $(this).slick(settings);
                          
                })
               }
}



// Parallax Background Image Js Start
		function ParallaxImage(){
			var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
			if(!isMobile) {
				if($(".custom-parallaxblock").length){  $(".custom-parallaxblock").ParallaxBackground({  invert: false });};    
			}else{
				$(".custom-parallaxblock").ParallaxBackground({  invert: true });	
			}	
		}

function stickyheader() {
  $(window).scroll(function(){
    if ($(window).scrollTop() >= 240) {
      $('.stickyheader').addClass("header-fixed");
    }   
    else{
      $('.stickyheader').removeClass("header-fixed");
    }
  });
}

function collectionViewMain(column_obj,removed_class){
  var class_list = Object.entries($("ul#product-grid").prop("classList"))
  $(".columns").each(function(){$(this).removeClass("active")});
  $(column_obj).addClass("active");
  for(i of class_list){
    if(i[1].match(removed_class)){
      $("ul#product-grid").removeClass(i[1]);
      break;
    }
  }
   var addable_class = "grid--"+column_obj.find("span.columns_number").text()+removed_class;
   $("ul#product-grid").addClass(addable_class)
}

function collectionView(){
  if($(window).width() > 991){
      var removable_class = "-col-desktop";
    }else if($(window).width() > 543 && $(window).width() < 992){
      var removable_class = "-tablet-down";
      $($("#product-grid").data("tablet")).trigger("click");
      $($("#product-grid").data("tablet")).addClass("active")
    }else if($(window).width() < 543){
      var removable_class = "-col-mobile";
      $($("#product-grid").data("mobile")).trigger("click");
      $($("#product-grid").data("mobile")).addClass("active");
    }
  $(".columns").on("click",function(){
    collectionViewMain($(this),removable_class);
  })
}

$(document).ready(function($) {

  $('#nothanks').on('click', function () {
    if (!jQuery.cookie('tt_popup_newsletter') || jQuery.cookie('tt_popup_newsletter') == null) {    
      $(window).on('load', function(){
        setTimeout($('.newsletter_popup').show(), 300 * 1000);
        jQuery('.newsletterclosepopup').click(function(e) {
          e.preventDefault();
          jQuery('.newsletter_popup').hide(); 
          jQuery.cookie('tt_popup_newsletter', '1', {expires: 1, path:'/', domain: '' });
                                                        });
        });
      }
    else {
        $('.newsletter_popup').remove();
    }
  });
   
  
  
   $('.newsletterclosepopup').on('click', function() {
      $('.newsletter_popup').addClass('d-none');
    });


});

$(window).scroll(function() {
  if ( $(document).scrollTop() >= 1000 ) {
      $('.popup').show();
  }
});

function searchSlider() {
  if($(document).width() < 992){
    $("header:not(.header--middle-left,.header--middle-center) > .header__icons details").attr("open",false)
  } 
  else{
    $("header:not(.header--middle-left,.header--middle-center) > .header__icons details").attr("open",true)
  }
}


  $(window).on('load', function(){
    slickCarousel();
  });


function footerToggle(){
  if($(document).width() < 768){
    $(".tt-footer-toggle .site-footer__item").click(function(){
      $(this).each(function(){
        $(this).find(".footer_main_title").toggleClass("active");
        $(this).find(".footer_main_desc").slideToggle();
      });
    });
  }
}

function staticLinksHeightMatch() {
  $("#custom-mainslider_v2 .section_main_categories").css("max-height",$("#custom-mainslider_v2").height());
}

function toggleStaticLinks(){
  $(".main_slider_v2_categories_title").click(function () {
    $(this) + $(".main_slider_v2_categories").slideToggle();
  })
}


function moveHeaderContact(){
  if($(window).width() <= 543){
    $(".header__icons .header_contact_info").appendTo("header-drawer .menu-drawer__utility-links");
  }else{
    $(".menu-drawer__utility-links > .header_contact_info").prependTo("header .header__icons");
  }
}

function blockScrolling(){
  $(".header__icon--menu,.product-popup-modal__button.link").click(function () {
    if ($(this).attr("aria-expanded") == "true") {
      $("html").css("overflow","hidden")  
    }
    else{
      $("html").css("overflow","auto")    
    }
  })
}

function moveContactHeaderTopCenter(){
  if($(window).width() > 990){
    $(".header.header--top-center .header_contact_info").insertBefore(".header.header--top-center > details-modal");
  }
  else{
    $(".header.header--top-center .header_contact_info").prependTo(".header.header--top-center .header__icons");
  }
}

function faqModal(){
  $(".faq_page_outer .faq_page_quest").click(function () {
    $(this).toggleClass("active").next().slideToggle().prev().siblings(".faq_page_quest").removeClass("active").siblings(".faq_page_quest:not(.active)").next().slideUp();;
  })
}

$(document).ready(function () {
  if(document.querySelector(".custom-parallaxblock") !== null){ParallaxImage();}
  stickyheader();
  footerToggle();
  collectionView();
  // searchSlider();
  toggleStaticLinks();
  staticLinksHeightMatch();
  moveContactHeaderTopCenter();
  moveHeaderContact();
  blockScrolling();
  faqModal();
});

$(document).ready(function(){
  $("#preloader").hide(); 
})



$(window).resize(function () {
  collectionView();
  staticLinksHeightMatch();
  moveContactHeaderTopCenter();
  moveHeaderContact();
  blockScrolling();
});




//QUICKVIEW SCRIPT START
  $(document).on("click",".quick-view",function() {
  	var handle = $(this).data("handle");
    loadQuickView(handle, $(this));
  });
  //QUICKVIEW SCRIPT END


//QUICKVIEW FUNCTIONS START

var variantAvailability = [];
var variantFeaturedImg = [];
var variantIndexIdMapping = [];
var currentVariants = {};
var availableVariants = [];
var variantCompareAtPrice = [];
var variantPrice = [];

function loadQuickView(handle,btn) {
  variantAvailability = [];
  variantFeaturedImg = [];
  variantIndexIdMapping = [];
  currentVariants = {};
  availableVariants = [];
  variantCompareAtPrice = [];
  variantPrice = [];
  $("#qv-variants").html('');
  
  jQuery.getJSON('/products/' + handle + '.js', function (product) {
    $("#qv-productname").html(product.title);
    $("#qv-productdescription").html(product.description);
    if(product.description.length < 300) {
    	$(".more-description").css("display","none");
    }else{
        $(".more-description").css("display","block");
    }
    $("#qv-product-cover img").attr("src",product.featured_image);
    var reviews = $('[data-handle="'+ handle +'"]').parents(".card-wrapper").find(".spr-badge").clone();
    $("#qv-spr-badge").html(reviews.html());

    //prepare thumbnails
    prepareQvThumbnails(product.images);

    if(product.variants.length > 1) {
      //prepare swatches
      var colorNameList = "color,colour,couleur,colore,farbe,색,色,färg,farve";
      colorNameList = colorNameList.split(",");
      $(product.options).each(function (i, option) {
        var name = option.name;
        var includesColor = colorNameList.includes(name.toLowerCase());
        var swatchWrapper = $('<div class="swatch-wrapper" data-index="' + option.position + '"></div>');
         var optionValues =  $('<div class="option-values product-form__input ' + name.toLowerCase() +'"></div>');
        swatchWrapper.append('<div class="option-label"><label>' + name + '</label></div>')
        $(option.values).each(function (i, value) {
          var checked = '';
          if(i==0) checked = 'checked';
          optionValues.append('<input id="' + name + '-' + i + '" type="radio" value="' + value + '" name="' + name +'"' + checked  +'>');
          var className = (includesColor || value.length < 3) ? "square" : "label"; 
          if(includesColor) {
            var dummyImg = "//cdn.shopify.com/s/files/1/0618/0601/8726/files/dummy?2609";
            var dummyImgURL = dummyImg.substr(0, dummyImg.indexOf('dummy'));
            var dummyImgVersion = dummyImg.substr(dummyImg.indexOf('?'));
            var imgURL = "background-color:" + value + "; background-image: url('"+ dummyImgURL + value + ".png" + dummyImgVersion +"')";
          	optionValues.append('<label style="'+ imgURL + '" for="' + name + '-' + i + '" class="' + className +'" data-index="'+ i +'"></label>');
          } else {
            optionValues.append('<label for="' + name + '-' + i + '" class="' + className +'" data-index="'+ i +'">' + value + '</label>');
          }
          
        });
        swatchWrapper.append(optionValues);
        $("#qv-variants").append(swatchWrapper);
      });    

      //prepare dropdown
      $(product.options).each(function (i, option) {
        var name = option.name;
        var selectWrapper = $('<div class="dropdown-wrapper"></div>');
        var optionValues = $('<div class="option-values product-form__input"></div>');
        var selectBoxWrapper =  $('<div class="select"></div>');
        var selectBox =  $('<select id="select-option' + option.position + '" name="options[' + option.position + ']" class="select__select"></select>');
        selectWrapper.append('<div class="option-label"><label>' + name + '</label></div>')
        $(option.values).each(function (i, value) {
          var selected = '';
          if(i==0) selected = 'selected';
          selectBox.append('<option value="' + value +'" ' + selected +'>' + value + '</option>');
        });
        selectBoxWrapper.append(selectBox);
        optionValues.append(selectBoxWrapper);
        selectWrapper.append(optionValues);
        $("#qv-variants").append(selectWrapper);
      });
      
      $(product.variants).each(function(index,variant) {
        var variantsList = variant.title.split("/");
        var variantsKeyVal = {};
        for(var i=0; i < variantsList.length; i++) {
          variantsKeyVal["select-option" + (i+1)] = variantsList[i].trim();
        }
        variantIndexIdMapping.push(variant.id);
        availableVariants.push(variantsKeyVal);
        variantAvailability.push(variant.available);
        variantCompareAtPrice.push(variant.compare_at_price);
        variantPrice.push(variant.price);
      });
      loadCurrentQvVariants();
      updateQvVariantDetails();
    } else {
      var variant = product.variants[0];
      $("#qv-variantid").val(variant.id);
      if(variant.available){
      	$("#qv-add-to-cart").removeClass("sold-out");
      } else {
      	$("#qv-add-to-cart").addClass("sold-out");
      }
      if(variant.compare_at_price != null && variant.compare_at_price > variant.price) {
        $("#qv-compareatprice").html(convertToMoney(variant.compare_at_price));
        $("#qv-price").html(convertToMoney(variant.price));
      } else {
        $("#qv-compareatprice").html('');
        $("#qv-price").html(convertToMoney(variant.price));
      }
      
    }
    $('.qv-wrapper').removeClass('loading');
  });
}

function addToCartJS(qty,variantID, btn) {   
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
          var parsedState = JSON.parse(xhr.responseText);
          window.scrollTo({top: 0, behavior: 'smooth'});
          document.querySelector('cart-notification').renderContents(parsedState);
		  btn.classList.remove("loading");
      }
    };
    var sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble"];
    var sections_url = window.location.pathname;
    var data = JSON.stringify({"quantity": qty, "id": variantID, "sections" : sectionsToRender, "sections_url" : sections_url });
    xhr.send(data);
}

function convertToMoney(price) {
  var price = parseFloat(price / 100).toFixed(2);
  var currency = document.getElementsByTagName("html")[0].getAttribute("currency");
  return currency + price; 
}

function prepareQvThumbnails(images) {
	var thumbnailContainer = $('#qv-thumbnails');
    var thumbnailSliderWrapper = $('<div class="owl-carousel"></div>')
    $(images).each(function (i,src) {
      thumbnailSliderWrapper.append('<div class="thumb-item item"><img src="' + src +'" alt="qv-img" ></div>');
    });
    thumbnailContainer.html(thumbnailSliderWrapper);
    thumbnailSliderWrapper.slick({
        slidesToShow: 4,
        slidesToScroll: 1
      });

}

function loadCurrentQvVariants() {
  //load current variants
  $('#qv-variants .dropdown-wrapper').each(function(index){
    currentVariants["select-option" + (index+1)] = $(this).find('select.select__select').val();
  });
}

function updateQvVariantDetails() {
  var index=0;
  var available = false;
  for(var i=0; i < availableVariants.length;) {
    if(matchArray(availableVariants[i],currentVariants)) {
      index = i;
    }
    if(matchArray(availableVariants[i],currentVariants) && variantAvailability[i]) {
      available = true;
      break;
    }
     i++;
  }
  
  $("#qv-variantid").val(variantIndexIdMapping[index]);
  
  if(available){
    $("#qv-add-to-cart").removeClass("sold-out");
  } else {
    $("#qv-add-to-cart").addClass("sold-out");
  }
  
  $("#qv-product-cover img").attr("src", variantFeaturedImg[index]);
  
   var price = variantPrice[index];
  var compare_at_price = variantCompareAtPrice[index];
  if(compare_at_price != null && compare_at_price > price) {
    $("#qv-compareatprice").html(convertToMoney(compare_at_price));
    $("#qv-price").html(convertToMoney(price));
  } else {
    $("#qv-compareatprice").html('');
    $("#qv-price").html(convertToMoney(price));
  }
  
}

function matchArray(a, b) {
  var match = true;
  for (var key in a) {
    if(a[key] != b[key]) {
      match = false;
    }
  }
  return match;
}

$(document).on("change","#qv-variants .select__select",function(){
  loadCurrentQvVariants();
  updateQvVariantDetails();
});
 
$(document).on("click",".swatch-wrapper label",function() {
  var selectorIndex = $(this).parents(".swatch-wrapper").data("index");
  var selector = "#select-option" + selectorIndex  + " option";
  var index = $(this).data("index");
  $(selector).eq(index).prop('selected', true).trigger('change');
});

$(document).on("click",".thumb-item",function(){
  $("#qv-product-cover img").attr("src",$(this).find("img").attr("src"))
});
 //CART BUTTONS SCRIPT START
  $(document).on("click",".add-to-cart-js",function() {
  	var variantID = this.getAttribute("data-variantid");
    $(this).addClass("loading");
    addToCartJS(1, variantID, this);
  });
  
  $(document).on("click",".cart-remove-js",function() {
  	var variantID = this.getAttribute("data-variantid");
    removeFromCartJS(variantID);
  });
  //CART BUTTONS SCRIPT END
$(document).on("click","#qv-add-to-cart",function(){
  if($(this).hasClass("sold-out")) return false;
  var variantId = $("#qv-variantid").val();
  var qty = $("#qv-quantity-selector input").val();
  $(this).addClass("loading");
  addToCartJS(qty,variantId, this);
  $("#ModalClose-quick-view").trigger("click");
});


     

//QUICKVIEW FUNCTIONS END
             
 //DEFAULT COLLAPSE JAVASCRIPT START
  $(document).on("click","[data-toggle='collapse']",function() {
    var parent = $(this).data("parent");
    var target = $(this).data("href");
    if($(parent).length && $(parent).hasClass('panel-group')) {
     $(parent+" .panel").each(function() {
       var p = $(this).find("[data-toggle='collapse']");
       var t = p.data("href");
       if(t!= target && p.attr("aria-expanded") == "true") {
        $(t).slideUp().removeClass("in");
        p.addClass("ishi-collapsed").attr("aria-expanded","false");
       } 
     });
    } 
    if($(this).attr("aria-expanded") == "false") {
      $(target).slideDown().addClass("in");
      $(this).removeClass("ishi-collapsed").attr("aria-expanded","true");
    } else {
      $(target).slideUp().removeClass("in");
      $(this).addClass("ishi-collapsed").attr("aria-expanded","false");
    }
  });
  //DEFAULT COLLAPSE JAVASCRIPT END
  
  //DEFAULT POPOVER JAVASCRIPT START
  $(document).on("click","[data-toggle='popover']",function() {
    var target = $(this).data("href");
    if($(this).attr("aria-expanded") == "false") {
      $(target).addClass("active");
      $(this).attr("aria-expanded","true");
    } else {
      $(target).removeClass("active");
      $(this).attr("aria-expanded","false");
    }
  });
$(document).on("click","#ModalClose-quick-view",function() {
$("#qvPopupModal").removeClass("active");
      $(".product-popup-modal__button").attr("aria-expanded","false"); 
   });
  
  $(document).on("click", function(event){
    if(!$(event.target).closest('#search-container-full').length && !$(event.target).closest('[data-href="#search-container-full"]').length){
      if($('[data-href="#search-container-full"]').attr("aria-expanded") == "true") {
        $("#search-container-full").removeClass("active");
        $('[data-href="#search-container-full"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#user-notification').length && !$(event.target).closest('[data-href="#user-notification"]').length){
      if($('[data-href="#user-notification"]').attr("aria-expanded") == "true") {
        $("#user-notification").removeClass("active");
        $('[data-href="#user-notification"]').attr("aria-expanded","false");
        event.preventDefault();
      }
    }
    
    if(!$(event.target).closest('#cart-notification').length && !$(event.target).closest('[data-href="#cart-notification"]').length){
      if($('[data-href="#cart-notification"]').attr("aria-expanded") == "true") {
        $("#cart-notification").removeClass("active");
        $('[data-href="#cart-notification"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#HeaderCountryList').length && !$(event.target).closest('[data-href="#HeaderCountryList"]').length){
      if($('[data-href="#HeaderCountryList"]').attr("aria-expanded") == "true") {
        $("#HeaderCountryList").removeClass("active");
        $('[data-href="#HeaderCountryList"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#HeaderLanguageList').length && !$(event.target).closest('[data-href="#HeaderLanguageList"]').length){
      if($('[data-href="#HeaderLanguageList"]').attr("aria-expanded") == "true") {
        $("#HeaderLanguageList").removeClass("active");
        $('[data-href="#HeaderLanguageList"]').attr("aria-expanded","false");
      }
    }
    
  });
  //DEFAULT POPOVER JAVASCRIPT END
                
    
                